<template>
<div class="d-flex justify-content-center min-vh-80">
  <div class="align-self-center flex-grow-1">
     <div class="plan-selector row my-md-5">
        <div id="package_1" @click="setSelected($event,6)" class="col-12 col-md col-lg col-sm-pull-4 plan order-2 order-md-1">
           <div class="d-none d-md-block">
              <div class="plan-box text-center">
                 <div class="checkmark">
                    <div class="glyphicon glyphicon-ok"></div>
                 </div>
                 <div class="plan-name">
                    Monthly
                 </div>
                 <div class="plan-amount">
                    <div class="price">
                       <div class="sup">
                          $
                       </div>
                       <div class="monthly-amount">
                          9.99
                       </div>
                    </div>
                    <div class="per-month">per month</div>
                 </div>
                 <div class="divider"></div>
                 <div class="billing-info">Billed $9.99 every month.</div>
                 <div class="thirty-day">
                    30-day money-back guarantee.
                 </div>
                 <div class="choose"><button type="button" class="btn btn-choose btn-block mx-auto d-block w-50">Choose</button></div>
              </div>
              <div role="alert" class="alert alert-dismissible alert-default">
                 <p class="mb-0"> Try the Yearly plan and save <b>22%</b></p>
              </div>
           </div>
           <div class="d-block d-md-none">
              <div class="plan-box">
                 <div class="plan-name">
                    <div class="plan-duration"><span class="months_number">Monthly</span></div>
                    <span class="savings-checkmark"><span class="checkmark"><span class="glyphicon glyphicon-ok"></span></span></span>
                 </div>
                 <div class="plan-amount">
                    <div class="price">
                       <div class="sup">
                          $
                       </div>
                       <div class="monthly-amount">
                          9.99
                       </div>
                    </div>
                    <div class="price-details">
                       <div class="per-month">
                          /
                          Month
                       </div>
                    </div>
                 </div>
                 <div class="divider"></div>
                 <div class="billing-info">Billed $9.99 every month.</div>
                 <div class="thirty-day">
                    30-day money-back guarantee.
                 </div>
              </div>
              <div role="alert" class="alert alert-dismissible alert-default">
                 <p class="mb-0">The 12-month plan offers the biggest savings and is fully refundable within 30 days.</p>
              </div>
           </div>
        </div>
        <div id="package_2" @click="setSelected($event,12)" class="col-12 col-md-5 col-lg-5 col-sm-push-4 plan best-deal order-1 order-md-2">
           <div class="d-none d-md-block">
              <div class="plan-box text-center">
                 <div class="best-deal-sticker"><span>
                    Most Popular
                    </span>
                 </div>
                 <div class="checkmark">
                    <div class="glyphicon glyphicon-ok"></div>
                 </div>
                 <div class="plan-name">
                    Yearly
                 </div>
                 <div class="crossed-out-price">
                    <div class="crossed-out-monthly-amount">$9.99</div>
                 </div>
                 <div class="plan-amount">
                    <div class="price">
                       <div class="sup">
                          $
                       </div>
                       <div class="monthly-amount">
                          7.77
                       </div>
                    </div>
                    <div class="per-month">per month</div>
                 </div>
                 <div class="divider"></div>
                 <div class="billing-info">Billed <span class="crossed-out-total">$361.35</span> $93.24 every 12 months.</div>
                 <div class="thirty-day">
                    30-day money-back guarantee.
                 </div>
                 <div class="savings">Save 74%</div>
                 <div class="choose"><button type="button" class="btn btn-choose btn-block mx-auto d-block w-50">Choose</button></div>
              </div>
           </div>
           <div class="d-block d-md-none mt-5">
              <div class="plan-box">
                 <div class="best-deal-sticker"><span>
                    Most Popular
                    </span>
                 </div>
                 <div class="plan-name">
                    <div class="plan-duration"><span class="months_number">Yearly</span></div>
                    <span class="savings-checkmark"><span class="savings">Save 22%</span> <span class="checkmark"><span class="glyphicon glyphicon-ok"></span></span></span>
                 </div>
                 <div class="plan-amount">
                    <div class="price">
                       <div class="sup">
                          $
                       </div>
                       <div class="monthly-amount">
                          7.77
                       </div>
                    </div>
                    <div class="price-details">
                       <div class="crossed-out-price">
                          <div class="crossed-out-monthly-amount">$9.99</div>
                       </div>
                       <div class="per-month">
                          /
                          Month
                       </div>
                    </div>
                 </div>
                 <div class="divider"></div>
                 <div class="billing-info">Billed <span class="crossed-out-total">$199.88</span> $93.24 every 12 months.</div>
                 <div class="thirty-day">
                    30-day money-back guarantee.
                 </div>
              </div>
           </div>
        </div>
        <div id="package_3" @click="setSelected($event,1)" class="col-12 col-md col-lg plan order-3">
           <div class="d-none d-md-block">
              <div class="plan-box text-center">
                 <div class="checkmark">
                    <div class="glyphicon glyphicon-ok"></div>
                 </div>
                 <div class="plan-name">
                    1 day Trial
                 </div>
                 <div class="plan-amount">
                    <div class="price">
                       <div class="sup">
                          $
                       </div>
                       <div class="monthly-amount">
                          0.99
                       </div>
                    </div>
                    <div class="per-month">per day</div>
                 </div>
                 <div class="divider"></div>
                 <div class="billing-info">Billed only once.</div>
                 <div class="thirty-day text-white">
                    30-day money-back guarantee.
                 </div>
                 <div class="choose"><button type="button" class="btn btn-choose btn-block mx-auto d-block w-50">Choose</button></div>
              </div>
              <div role="alert" class="alert alert-dismissible alert-default">
                 <p class="mb-0">Try the Yearly plan and save <b>74%</b></p>
              </div>
           </div>
           <div class="d-block d-md-none">
              <div class="plan-box">
                 <div class="plan-name">
                    <div class="plan-duration"><span class="months_number">1 day Trial</span></div>
                    <span class="savings-checkmark"><span class="checkmark"><span class="glyphicon glyphicon-ok"></span></span></span>
                 </div>
                 <div class="plan-amount">
                    <div class="price">
                       <div class="sup">
                          $
                       </div>
                       <div class="monthly-amount">
                          0.99
                       </div>
                    </div>
                    <div class="price-details">
                       <div class="per-month">
                          /
                          Day
                       </div>
                    </div>
                 </div>
                 <div class="divider"></div>
                 <div class="billing-info">Billed only once.</div>
              </div>
              <div role="alert" class="alert alert-dismissible alert-default">
                 <p class="mb-0">The 12-month plan offers the biggest savings and is fully refundable within 30 days.</p>
              </div>
           </div>
        </div>
     </div>
  </div>
</div>
</template>
<script>
  export default {

    data() {
      return {
        form: {}
      };
    },
    methods: {
      setSelected(e,months){
        $('.try-yearly-plan').addClass("d-none");
        $('.alert-six-months').addClass("d-none");
        $('.plan').removeClass("selected");
        $('#'+e.currentTarget.id).addClass("selected");
        if(months == 1 || months == 6){
          $('.try-yearly-plan').removeClass("d-none");
        }

      },
      
    }
  }
</script>
